import { render, staticRenderFns } from "./DispensaryCategories.vue?vue&type=template&id=377ab39c&scoped=true&"
import script from "./DispensaryCategories.vue?vue&type=script&lang=js&"
export * from "./DispensaryCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377ab39c",
  null
  
)

export default component.exports